import { useContext } from 'react';
import Skeleton from 'react-loading-skeleton';
import Typography from 'components/gruenland/atoms/typography';
import { AccountContext } from 'context/account';
import { useFormat } from 'helpers/hooks/useFormat';
import { TYPOGRAPHY_PRIVATE_AREA_TITLE } from 'lib/typography';
import Integrity from './sections/integrity';
import PersonalInfo from './sections/personal-info';

const MyAccount: React.FC = () => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  const { account, accountLoading: isLoading } = useContext(AccountContext);

  return (
    <>
      {isLoading ? (
        <Skeleton className="h-[30px] max-w-[300px]" />
      ) : (
        <Typography as="h3" className={TYPOGRAPHY_PRIVATE_AREA_TITLE}>
          {formatMessage({ id: 'privatearea.menu.profile', defaultMessage: 'Profilo' })}
        </Typography>
      )}
      {isLoading ? (
        <Skeleton className="max-w-[400px]" />
      ) : (
        <Typography>{formatMessage({ id: 'account.manage', defaultMessage: 'Gestisci il tuo account' })}</Typography>
      )}

      {/* Sections */}
      <div className="grid gap-8 md:gap-6 lg:gap-12">
        {isLoading ? (
          <Skeleton className="h-[350px]" />
        ) : (
          <>
            <PersonalInfo />

            <Integrity />
          </>
        )}
      </div>
    </>
  );
};

export default MyAccount;
